export default "__VITE_ASSET__DJxcQ1LM__"